import { render, staticRenderFns } from "./dev_type.vue?vue&type=template&id=46b2267f&scoped=true&"
import script from "./dev_type.vue?vue&type=script&lang=js&"
export * from "./dev_type.vue?vue&type=script&lang=js&"
import style0 from "./dev_type.vue?vue&type=style&index=0&id=46b2267f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2267f",
  null
  
)

export default component.exports